<div class="flex flex-col -m-6 h-full">

  <!-- Header -->
  <div class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
    <div class="text-lg font-medium">{{ data.file.filename }}</div>
    <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
      <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="place-items-center h-[90%] w-full">
    <div class="m-6 h-full">
      <!-- image from url -->
      @if (data.file.isImage && data.file.imageUrl && !data.file.base64) {
        <img class="h-full aspect-auto"
          [src]="data.file.imageUrl">
      }

      <!-- image from base 64 -->
      @if (data.file.isImage && data.file.base64) {
        <img class="h-full aspect-auto"
          [src]="data.file.base64">
      }
    </div>
  </div>
</div>